
import { Component, Prop, Vue } from "vue-property-decorator";
import { API_TCaseCategory, API_TCaseProfile } from "@/models/case_profiles";
import { SMApp } from "@/store";

const COL_SPAN_CLASS = "col-span";

@Component({
  components: {
    ProfileTemplate: () => import("@/components/ProfileTemplate/ProfileTemplate.vue"),
    AdvisorNotes: () => import("@/components/Widgets/Expert/AdvisorNotes.vue"),
  },
})
export default class VExpertTemplateProfile extends Vue {
  @Prop({ type: [Object, String], default: () => ({}) }) readonly src?: API_TCaseProfile;
  @Prop({ type: Number, default: 0 }) readonly serviceId?: number;
  @Prop({ type: Boolean, default: false }) readonly isEditable?: boolean;

  get categories(): API_TCaseCategory[] {
    return this.src?.categories ?? [];
  }

  get classes() {
    return `${COL_SPAN_CLASS}-${this.columns}`;
  }

  // TODO: DEV-1752. Move all "AdvisorNotes" logic to global portal;
  get noteActive() {
    return SMApp.noteActive;
  }

  beforeCreate() {
    SMApp.hideNotes();
  }

  get columns() {
    return this.noteActive ? 8 : 12;
  }

  serviceEditCheck(payload: { caseId: number; stepId: number; type: string }): void {
    this.$emit("edit", payload);
  }
}
